import React from 'react'
import { Form, Input, Button, Modal, Select, Tooltip, Icon } from 'antd'
import {
  TYPE_CHAT_LABELS,
  TYPE_CHAT_TELEGRAM,
  TYPE_CHAT_VIBER,
  TYPE_CHAT_VK,
} from '../../../../shared/utils/constant'
import InputColor from '../../../../components/InputColor'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select


class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => {
      this.props.onDelete()
    }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const {
      getFieldDecorator,
      getFieldValue,
    } = this.props.form

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }

    /**
     * Component fields which depend on selected messenger type.
     * @param formItemLayout
     * @param getFieldDecorator
     */
    const chatbotCreatingFields = ({
      [TYPE_CHAT_TELEGRAM]: <React.Fragment />,
      [TYPE_CHAT_VK]: (
        <React.Fragment>
          <FormItem
            label='Цвет кнопки:'
            {...formItemLayout}
          >
            {getFieldDecorator('s_btn_color', {
              rules: [{
                message: `Пожалуйста, выберите цвет кнопки.`,
              }],
            })(<Select style={{ width: 120 }} >
              <Option value='primary'>Primary</Option>
              <Option value='secondary'>Secondary</Option>
              <Option value='positive'>Positive</Option>
              <Option value='negative'>Negative</Option>
            </Select>)}
          </FormItem>
          <FormItem
            label={
              <span>
                Возвращаемая строка&nbsp;
                <Tooltip
                  title='Введите строку, которую должен вернуть сервер, полученную на шаге 6 (вики).'
                >
                  <Icon type='question-circle-o' />
                </Tooltip>
              </span>
            }
            {...formItemLayout}
          >
            {getFieldDecorator('s_conf_token', {
              rules: [{
                message: 'Пожалуйста, введите уникальный идентификатор, обычно ' +
                  'то же замое значение, что и uri чатбота Viber.',
              }],
            })(<TextArea rows={3} placeholder='Token' />)}
          </FormItem>
        </React.Fragment>
      ),
      [TYPE_CHAT_VIBER]: (
        <React.Fragment>
          <FormItem
            label={
              <span>
                Приветсвтенное сообщение&nbsp;
              </span>
            }
            {...formItemLayout}
          >
            {getFieldDecorator('s_welcome_message', {
              rules: [{
                message: 'Пожалуйста, введите приветсвтенное сообщение чатбота',
              }],
            })(<TextArea rows={3} placeholder='URL' />)}
          </FormItem>
          <FormItem label='Цвет фона:' {...formItemLayout}>
            {getFieldDecorator('s_bck_color', {
              initialValue: '',
              rules: [{ message: 'Пожалуйста, выберите цвет фона' }],
            })(<InputColor
              placeholder='Выберите цвет фона'
            />)}
          </FormItem>
          <FormItem
            label={
              <span>
                Цвет чат бота&nbsp;
                <Tooltip title='Основной цвет чат бота, полученный на шаге 1.'>
                  <Icon type='question-circle-o' />
                </Tooltip>
              </span>
            }
            {...formItemLayout}
          >
            {getFieldDecorator('s_btn_color', {
              initialValue: '',
              rules: [{ message: 'Пожалуйста, цвет фона.' }],
            })(<InputColor
              placeholder='Выберите основной цвет чат бота'
            />)}
          </FormItem>
          <FormItem label='Цвет текста' {...formItemLayout}>
            {getFieldDecorator('s_txt_color', {
              initialValue: '',
              rules: [{ message: 'Пожалуйста, выберите цвет текста' }],
            })(<InputColor
              placeholder='Выберите основной цвет текста'
            />)}
          </FormItem>
          <FormItem
            label={
              <span>
                Ссылка на аватарку&nbsp;
                <Tooltip
                  title='Введите ссылку на аватарку, получнную на шаге 3. Ссылка должна указывать на аватарку viber.'
                >
                  <Icon type='question-circle-o' />
                </Tooltip>
              </span>
            }
            {...formItemLayout}
          >
            {getFieldDecorator('s_url_image', {
              rules: [{
                message: 'Пожалуйста, введите ссылку на аватарку чатбота',
              }],
            })(<TextArea rows={3} placeholder='URL' />)}
          </FormItem>
        </React.Fragment>
      ),
    })


    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'

    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Тип' {...formItemLayout}>
          {getFieldDecorator('n_type', {
            rules: [{
              required: true,
              message: 'Пожалуйста введите тип.',
            }],
          })(<Select
            placeholder='Тип'
            disabled={!isCreateForm}
          >
            {
              Object.entries(TYPE_CHAT_LABELS)
                .map(item => <Option key={item[0]} value={item[0]}>{item[1]}</Option>)
            }
          </Select>)}
        </FormItem>
        <FormItem label='Уникальный идентификатор' {...formItemLayout}>
          {getFieldDecorator('s_name', {
            rules: [{
              required: true,
              message: 'Пожалуйста введите уникальный идентификатор, обычно ' +
                'то же замое значение, что и uri чатбота Viber.',
            }],
          })(<TextArea rows={3} placeholder='Имя' disabled={!isCreateForm} />)}
        </FormItem>

        <FormItem label='Токен чатбота' {...formItemLayout}>
          {getFieldDecorator('s_api_token', {
            rules: [{
              required: true,
              message: 'Пожалуйста введите api Token для чатбота.',
            }],
          })(<TextArea rows={3} placeholder='Api Token' disabled={!isCreateForm} />)}
        </FormItem>
        {chatbotCreatingFields[getFieldValue('n_type')]}
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Удалить
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      n_type: Form.createFormField(formFieldValues.n_type),
      s_name: Form.createFormField(formFieldValues.s_name),
      s_api_token: Form.createFormField(formFieldValues.s_api_token),
      s_url: Form.createFormField(formFieldValues.s_url),
      s_btn_color: Form.createFormField(formFieldValues.s_btn_color),
      s_bck_color: Form.createFormField(formFieldValues.s_bck_color),
      s_conf_token: Form.createFormField(formFieldValues.s_conf_token),
      s_txt_color: Form.createFormField(formFieldValues.s_txt_color),
      s_url_image: Form.createFormField(formFieldValues.s_url_image),
      s_welcome_message: Form.createFormField(formFieldValues.s_welcome_message),
    }
  },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/SellerForm/ChatList/Form/ChatForm.jsx